import { StudioStore } from './StudioStore'

export const PlayerStore = StudioStore.named('player')
